export default __webpack_public_path__ + "static/media/customize3.e2f21e07.webp";